var zindexModalBackground = 1040;
var zindexModal = 1050;

export { zindexModal, zindexModalBackground };
